import { supabase } from './supabase'

const CATEGORY_MAP = {
  1: 'corporate_structure',
  2: 'core_financials',
  3: 'team_human_capital',
  4: 'risk_compliance_esg',
  5: 'legal_protection',
}

const CATEGORY_LABELS = {
  corporate_structure: 'Corporate',
  core_financials: 'Financial',
  team_human_capital: 'Team',
  risk_compliance_esg: 'Risk',
  legal_protection: 'Legal',
}

export function calculateScore(documents) {
  if (!documents || documents.length === 0) {
    return {
      overall: 0,
      corporate_structure: 0,
      core_financials: 0,
      team_human_capital: 0,
      risk_compliance_esg: 0,
      legal_protection: 0,
    }
  }

  const goodStatuses = ['uploaded', 'awaiting', 'verified']
  const overall = Math.round(
    documents.filter((d) => goodStatuses.includes(d.status)).length / documents.length * 100
  )

  const breakdown = {}
  for (const [catId, key] of Object.entries(CATEGORY_MAP)) {
    const catDocs = documents.filter((d) => d.category === parseInt(catId))
    if (catDocs.length === 0) {
      breakdown[key] = 0
    } else {
      breakdown[key] = Math.round(
        catDocs.filter((d) => goodStatuses.includes(d.status)).length / catDocs.length * 100
      )
    }
  }

  return { overall, ...breakdown }
}

export async function recalculateScore(companyId) {
  const { data: docs } = await supabase
    .from('governance_documents')
    .select('status, category')
    .eq('company_id', companyId)

  const score = calculateScore(docs || [])

  await supabase
    .from('companies')
    .update({ governance_score: score.overall, updated_at: new Date().toISOString() })
    .eq('id', companyId)

  return score
}

export function getScoreLabel(score) {
  if (score >= 70) return 'Venture-Grade'
  if (score >= 41) return 'Building'
  return 'Early Stage'
}

export function getScoreColor(score) {
  if (score >= 70) return { bar: 'bg-emerald-500', text: 'text-emerald-700' }
  if (score >= 41) return { bar: 'bg-amber-500', text: 'text-amber-700' }
  return { bar: 'bg-rose-500', text: 'text-rose-700' }
}

export { CATEGORY_LABELS }
